import { LDFlagSet } from 'launchdarkly-js-client-sdk';

import { useFlags } from '@project44/feature-flags';
import { useUser } from '@project44/ui-utils';

export type TFeatureFlags = {
  featureExc1365: boolean; // Enable Contains Option
  featureExc2157: boolean; // Notifications
  featureExc2171: boolean; // Chat Waitlist Banner
  featureExc2241: boolean; // Master Sort/Export Button Versions
  featureNx726: boolean; // Carrier Welcome Banner
  incidentSuggestionCard: boolean; // Panama Canal Delays
};

export type TPermissions = {
  canViewChat: boolean; // Chatbot
  canViewOrders: boolean; // Allow Orders List
};

export type TusePermissions = {
  flags: LDFlagSet;
  permissions: TPermissions;
};

function usePermissions() {
  const { data: user } = useUser();
  const flags = useFlags();

  const isAllowed = (token: string) =>
    Boolean(user?.authorities?.some(({ authority }) => authority === token));

  return {
    flags,
    permissions: {
      canViewChat: isAllowed('create:movement-ai-bot-chats'),
      canViewOrders: isAllowed('ORDER_VISIBILITY_UI'),
    },
  };
}

export default usePermissions;
